"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getUserBase64 = getUserBase64;
var _base = _interopRequireDefault(require("base-64"));
/**
 * get user base 64
 * @param email
 * @returns {string}
 */
function getUserBase64(email) {
  return _base.default.encode(email.replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
    return String.fromCharCode(`0x${p1}`);
  }));
}